import { WorkoutGuard } from './../@auth/guards/workout.guard';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { FrontendsComponent } from './frontends.component';
import { AssessmentInputComponent } from '../pages/CalorieFriend/Customers/Assessments/assessment.component';
import { PatientProgressComponent } from 'app/pages/CalorieFriend/PatientSheetView/patient-progress/patient-progress.component';
import { PatientMealPlanViewComponent } from './patient-meal-plan-view/patient-meal-plan-view.component';
import { PatientFitnessPlanViewComponent } from './patient-fitness-plan-view/patient-fitness-plan-view.component';
import { PatientProfileComponent } from './patient-profile/patient-profile.component';
import { PatientGoalsComponent } from './patient-goals/patient-goals.component';
import { PatientProfileInvalidComponent } from './patient-profile-invalid/patient-profile-invalid.component';
import { PatientCheckinComponent } from './patient-checkin/patient-checkin.component';
import { PatientCalendarViewComponent } from './patient-calendar-view/patient-calendar-view.component';
import { FoodDiaryContainerComponent } from './food-tracking/food-diary-container/food-diary-container.component';
import { PatientFitnessWorkoutLogsViewComponent } from './patient-fitness-workout-logs-view/patient-fitness-workout-logs-view.component';
import { PatientInvoicesComponent } from './patient-billing/patient-invoices/patient-invoices.component';
import { PatientInvoiceViewComponent } from './patient-billing/patient-invoice-view/patient-invoice-view.component';
import { PatientBillingComponent } from './patient-billing/patient-billing.component';
import { PatientSubscriptionViewComponent } from './patient-billing/patient-subscription-view/patient-subscription-view.component';
import { PatientSubscriptionMetaViewComponent } from './patient-billing/patient-subscription-meta-view/patient-subscription-meta-view.component';

const routes: Routes = [
  {
    path: '',
    component: FrontendsComponent,
    children: [
      {
        path: 'weekly-assessment/:NotificationToken/:guid',
        component: AssessmentInputComponent,
      },
      {
        path: 'Patient/:NotificationToken/Meal/:PlanId',
        component: PatientMealPlanViewComponent,
      },
      {
        canDeactivate: [WorkoutGuard],
        path: 'Patient/:NotificationToken/Workout/:PlanId',
        component: PatientFitnessPlanViewComponent,
      },
      {
        path: 'Patient/:NotificationToken/Workout/Logs/:WorkoutId',
        component: PatientFitnessWorkoutLogsViewComponent,
      },
      {
        path: 'GeneralInfo/:NotificationToken',
        component: PatientProfileComponent,
      },
      {
        path: 'Patient/:NotificationToken',
        component: PatientMealPlanViewComponent,
      },
      {
        path: 'Patient/:NotificationToken/m/:PlanId',
        component: PatientMealPlanViewComponent,
      },
      {
        path: 'Patient/:NotificationToken/w/:PlanId',
        component: PatientFitnessPlanViewComponent,
      },
      {
        path: ':NotificationToken/m/:PlanId',
        component: PatientMealPlanViewComponent,
      },
      {
        path: ':NotificationToken/w/:PlanId',
        component: PatientFitnessPlanViewComponent,
      },
      {
        path: ':NotificationToken',
        component: PatientProfileComponent,
      },
      {
        path: ':NotificationToken',
        component: PatientMealPlanViewComponent,
      },
      {
        path: 'PatientAssessment/:NotificationToken',
        component: PatientProgressComponent,
      },
      {
        path: 'PatientGoals/:NotificationToken',
        component: PatientGoalsComponent,
      },
      {
        path: 'Invalid/:NotificationToken',
        component: PatientProfileInvalidComponent,
      },
      {
        path: ':NotificationToken/Checkin',
        component: PatientCheckinComponent,
      },
      {
        path: 'calendar/:patientGuid',
        component: PatientCalendarViewComponent,
      },
      {
        path: 'food/:patientGuid',
        component: FoodDiaryContainerComponent,
      },
      {
        path: 'billing/:patientGuid',
        component: PatientBillingComponent,
      },
      {
        path: 'billing/:patientGuid/invoices',
        component: PatientInvoicesComponent,
      },
      {
        path: 'billing/:patientGuid/invoices/:invoiceId',
        component: PatientInvoiceViewComponent,
      },
      {
        path: 'billing/:patientGuid/subscriptions/:subscriptionId',
        component: PatientSubscriptionViewComponent,
      },
      {
        path: 'billing/:patientGuid/subscriptions/meta/:subscriptionMetaId',
        component: PatientSubscriptionMetaViewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FrontendsRoutingModule {}
